export enum SUBSCRIPTION_STATUS {
    ACTIVE = 'active',
    TRIALING = 'trialing',
    CANCELLED = 'cancelled',
    ENDED = 'ended',
    FROZEN = 'frozen',
}

export enum PLAN_CHANGE_STATUS {
    SCHEDULED = 'scheduled',
    APPLIED = 'applied',
    CANCELLED = 'cancelled',
    FAILED = 'failed',
}

/** UI-only discriminator for the create form; stripped before the payload is sent. */
export enum TRIAL_MODE {
    PLAN_DEFAULT = 'plan_default',
    NONE = 'none',
    CUSTOM = 'custom',
}

/** Present on the retrieve serializer only. */
export type ScheduledPlanChange = {
    id: string;
    target_service_plan: {
        id: string;
        name: string;
    };
    effective_date: string;
    status: PLAN_CHANGE_STATUS;
};

export type Subscription = {
    id: string;
    created_at: string;
    modified_at: string;
    reference: string;
    external_id: string | null;
    start_date: string | null;
    end_date: string | null;
    status: SUBSCRIPTION_STATUS;
    cancelled_at: string | null;
    locked_at: string | null;
    stopped_on: string | null;
    has_active_billing: boolean | null;
    billing_start_date: string | null;
    /** Read-only. */
    trial_start: string | null;
    /** Writable on create only; read-only thereafter. */
    trial_end: string | null;
    /** Read-only, internal. Never displayed. */
    trial_ending_notified_at: string | null;
    /** Null when no change is pending. Only the retrieve endpoint returns it. */
    scheduled_plan_change: ScheduledPlanChange | null;
    service_plan: {
        id: string;
        name: string;
    };
    customer: {
        id: string;
        name: string;
    };
};
